import { useEffect, useState } from "react";

import { Env } from "../../common/constants/env";

const isDesktopViewport = () =>
  window.innerWidth > Env.MIN_DESKTOP_VIEWPORT_WIDTH;

export const useIsDesktopViewport = () => {
  const [isDesktop, setIsDesktop] = useState(isDesktopViewport);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(isDesktopViewport());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isDesktop;
};
